<script setup lang="ts">
import { onMounted, ref } from "vue";
import { IconName, getIconByName } from "./utils";

defineProps<{ name: IconName }>();

const isLoaded = ref(false);

onMounted(() => {
  isLoaded.value = true;
});
</script>

<template>
  <component v-if="isLoaded" :is="getIconByName(name)" class="inline-block" />
</template>
